import { Avatar, Button, Col, DatePicker, Form, Input, Modal, Row } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { isAuthenticated } from "../../../commons/Auth/auth";
import MainButtonComp from "../../../commons/Buttons/MainButtonComp";
import DragUpload from "../../../commons/DragUpload/DragUpload";
import { Error, Success } from "../../../commons/Messages/Messages";

import { useTranslation } from "react-i18next";
const UpdateProfile = ({ data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [loading, setLoading] = useState(false);
  const [picture, setPicture] = useState(data?.picture);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async formValues => {
    setLoading(true);
    const values = {
      ...formValues,

      // dob: formValues["dob"].format("DD-MM-YYYY"),
      picture: picture
    };
    await axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/users/update-profile/${isAuthenticated()?.serviceProviderId}`,
        values,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          updateParent();
          handleCancel();
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        if (err?.response && err?.response?.data && err?.response?.data?.errors) {
          const validationErrors = err?.response?.data?.errors;
          const errorMessage = Object.values(validationErrors)
            ?.map(err => `${err?.path} is ${err?.kind}.`)
            .join("\n");
          Error(errorMessage);
        } else if (err?.response?.data?.keyPattern) {
          Error(Object.keys(err?.response?.data?.keyPattern) + " already exists");
        } else {
          Error(err.message);
        }
      });
  };

  const onFinishFailed = errorInfo => {};

  const initialDate = data.dob ? moment(data.dob, "DD-MM-YYYY") : null;

  return (
    <div>
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <Modal
        destroyOnClose
        title={t("Personal Details")}
        width={720}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {t("Cancel")}
          </Button>,
          <Button
            key="submit"
            loading={loading}
            type="primary"
            htmlType="submit"
            form="admin-update-profile"
          >
            {t("Submit")}
          </Button>
        ]}
      >
        <Form
          id="admin-update-profile"
          size="large"
          name="basic"
          initialValues={{ ...data, dob: initialDate }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} className="mb-4">
              {picture?.url && (
                <div className="mb-3">
                  <Avatar src={picture?.url} alt="" size={100} />
                </div>
              )}
              <DragUpload noMultiple updateFiles={val => setPicture(val[0]?.response)} />
            </Col>
            <Col xs={24} md={24}>
              <Form.Item
                label={t("Description")}
                name="description"
                rules={[
                  {
                    required: true,
                    message: t("Please enter description!")
                  }
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("First Name")}
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: t("Please enter firstName!")
                  }
                ]}
              >
                <Input autoComplete="given-name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Last Name")}
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: t("Please enter lastName!")
                  }
                ]}
              >
                <Input autoComplete="family-name" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Date of birth")}
                name="dob"
                rules={[
                  {
                    required: true,
                    message: t("Please enter Date of birth!")
                  }
                ]}
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  disabledDate={current => current && current > new Date()}
                  className="w-100"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Email")}
                name="email"
                rules={[
                  {
                    required: true,
                    message: t("Please enter email!")
                  }
                ]}
              >
                <Input type="email" inputMode="email" autoComplete="email" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Phone")}
                name="phone"
                rules={[
                  {
                    required: true,
                    message: t("Please enter phone!")
                  }
                ]}
              >
                <Input type="tel" inputMode="tel" autoComplete="tel" />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <h5 className="form-title">
                <span>{t("Bank Detail")}</span>
              </h5>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label={t("Iban")} name="iban">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <h5 className="form-title">
                <span>{t("Address")}</span>
              </h5>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("City")}
                name="city"
                rules={[
                  {
                    required: true,
                    message: t("Please enter city!")
                  }
                ]}
              >
                <Input autoComplete="address-level2" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("State")}
                name="state"
                rules={[
                  {
                    required: true,
                    message: t("Please enter state!")
                  }
                ]}
              >
                <Input autoComplete="address-level1" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Zip Code")}
                name="zipCode"
                rules={[
                  {
                    required: true,
                    message: t("Please enter Zip Code!")
                  }
                ]}
              >
                <Input autoComplete="postal-code" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Country")}
                name="country"
                rules={[
                  {
                    required: true,
                    message: t("Please enter country!")
                  }
                ]}
              >
                <Input autoComplete="country-name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default UpdateProfile;
